// extracted by mini-css-extract-plugin
module.exports = {"passDiv":"style_passDiv__sYLIa","formDiv":"style_formDiv__2PR3i","form":"style_form__1rhE5","head":"style_head__1g4O_","input":"style_input__2szqZ","button":"style_button__zoyIa"};